
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/gradeChangeLoggingContent';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div id=\"grade_change_activity_form_mount_point\"></div>\n\n<hr aria-hidden=\"true\"/>\n\n<div id=\"gradeChangeLoggingSearchResults\"></div>\n";
  });
    ;
    ;
    export default templates[name];
  